'use client';

import { createContext, useState } from 'react';
import React from 'react';

type ActionState =
  | {
      state: 'initial';
    }
  | { state: 'subscribed'; activeMailId: number; emailAddress: string }
  | { state: 'unsubscribed' };

type ActiveMailerState = {
  actionState: ActionState;
  setActionState: (state: ActionState) => void;
};

const ActiveMailerContext = createContext<ActiveMailerState | undefined>(undefined);

export function ActiveMailerContextProvider({
  children,
  initialActionState = { state: 'initial' }
}: {
  children: React.ReactNode;
  initialActionState?: ActionState;
}) {
  const [actionState, setActionState] = useState<ActionState>(initialActionState);

  return (
    <ActiveMailerContext.Provider
      value={{
        actionState,
        setActionState
      }}
    >
      {children}
    </ActiveMailerContext.Provider>
  );
}

export function useActiveMailerContext() {
  const context = React.useContext(ActiveMailerContext);

  if (!context) {
    throw new Error('useActiveMailerContext must be used within a ActiveMailerContextProvider');
  }

  return context;
}
